import { forwardRef, createElement } from 'react';
import { Root, Trigger, Content, Arrow } from '@radix-ui/react-tooltip';

const Tooltip = /*#__PURE__*/forwardRef(function Tooltip(props, ref) {
  const {
    title,
    children,
    placement,
    ...otherProps
  } = props;
  return createElement(Root, {
    delayDuration: 50
  }, createElement(Trigger, {
    asChild: true,
    ref: ref
  }, children), createElement(Content, Object.assign({}, otherProps, {
    asChild: true,
    side: placement,
    sideOffset: 3
  }), createElement("div", {
    className: "wcag-purple xs:max-w-[theme(spacing.56)] max-w-[theme(spacing.32)] animate-[fade-in_150ms] rounded-sm px-2 py-1 text-xs font-bold opacity-90",
    "data-taco": "tooltip",
    style: {
      transformOrigin: 'var(--radix-tooltip-content-transform-origin)'
    }
  }, createElement(Arrow, {
    className: "fill-purple stroke-purple"
  }), title)));
});

export { Tooltip };
//# sourceMappingURL=Tooltip.js.map
